import type { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
	{
		path: "/platform-member",
		children: [
			{
				path: "",
				name: "platformMember",
				component: () => import("@/views/platformMembers/home.vue"),
				meta: {
					title: "龙悦会员",
					keepAlive: true,
					pageInfo: {
						pageID: 10722,
						pageName: "会员大厅页"
					}
				}
			},
			{
				path: "myGrowth",
				name: "platformMemberMyGrowth",
				component: () => import("@/views/platformMembers/myGrowth.vue"),
				meta: {
					title: "我的成长值",
				}
			},
			{
				path: "rules",
				name: "platformMemberRules",
				component: () => import("@/views/platformMembers/rules.vue"),
				meta: {
					title: "会员规则",
					keepAlive: false
				}
			}
		]
	}
];

export default routes;
